import request from '@/utils/request'

const userApi = {
  Login: '/fds/auth/login',
  Logout: '/fds/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/fds/auth/info',
  UserMenu: '/user/nav',
}

/**
 * login func1
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter,
  })
}

export function getSmsCaptcha(parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter,
  })
}

export function getInfo() {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

export function getCurrentUserNav() {
  return request({
    url: userApi.UserMenu,
    method: 'get',
  })
}

export function logout() {
  return request({
    url: userApi.Logout,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter,
  })
}
//动态路由
export function getAsyncRouter() {
  return request({
    url: '/fds/auth/getRouters',
    method: 'get',
  })
}
//租户id
export function getTenantIdByDomain(domain) {
  return request({
    url: `/fds/auth/getTenantByDomain?domain=${domain}`,
    method: 'get',
  })
}
//判断初始化
export function initSystemStatus() {
  return request({
    url: '/fds/system/initSystemStatus',
    method: 'get',
  })
}
//验证码
export function captcha() {
  return request({
    url: '/fds/auth/captcha',
    method: 'get',
  })
}
//修改
export function updatePasswordLogin(params) {
  return request({
    url: '/fds/my/updatePasswordLogin',
    method: 'POST',
    params: params,
  })
}
export function getTenantByName(params) {
  return request({
    url: '/fds/auth/getTenantByName',
    method: 'get',
    params: params,
  })
}
